import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a87f53b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "warning_note" }
const _hoisted_2 = { "data-test": "warning-note-title" }
const _hoisted_3 = { "data-test": "warning-note-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_warning_icon_svg = _resolveComponent("app-warning-icon-svg")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _createVNode(_component_app_warning_icon_svg, {
        class: "warning_note__icon",
        fill: "rgba(220, 165, 0, 0.3)"
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("ex.warning.title")), 1)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("ex.warning.text")), 1)
  ]))
}